import React from 'react';
import { useSearchkit } from '@searchkit/client';
import Button from '../../../../Button';
var DateRangeFilter = function DateRangeFilter(_ref) {
  var filter = _ref.filter,
    loading = _ref.loading;
  var api = useSearchkit();
  return /*#__PURE__*/React.createElement(Button, {
    disabled: loading,
    onClick: function onClick() {
      api.removeFilter(filter);
      api.search();
    }
  }, filter.label, ": ", new Date(filter.dateMin).toDateString(), " -", ' ', new Date(filter.dateMax).toDateString());
};
export default DateRangeFilter;